import React, { useState, useEffect } from 'react';
import { FaArrowRight }                 from 'react-icons/fa';
import { useNavigate }                  from 'react-router-dom';
import api                              from '../Axios/axios';
import Navbar                           from '../Navbar/Navbar';
import './ConstructionCompanyList.scss';

export default function ConstructionCompanyList() {
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [reports, setReports]     = useState({});
  const [loading, setLoading]     = useState(true);
  const [sortCol, setSortCol]     = useState('remaining');
  const [sortDir, setSortDir]     = useState('desc');

  // TL formatlama fonksiyonu
  const fmtTL = n => {
    // null/undefined kontrolü
    const num = Number(n) || 0;
    return num.toLocaleString('tr-TR') + ' TL';
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const compRes = await api.get('/Company');
        const renters = compRes.data.data.filter(c => c.rentTowerCrane);
        const repMap = {};
        await Promise.all(
          renters.map(async c => {
            const repRes = await api.get(
              `/Rental/Report/${c.id}?rentTowerCrane=true`
            );
            repMap[c.id] = repRes.data.data;
          })
        );
        setCompanies(renters);
        setReports(repMap);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="construction-list">
        <Navbar />
        <div className="construction-list__content">Yükleniyor…</div>
      </div>
    );
  }

  const data = companies
    .map(c => {
      const rep = reports[c.id] || {};
      const totalProgress = (rep.totalContractPrice || 0) + (rep.totalServiceAmount || 0);
      const totalPaid     = rep.totalConstructionPayment || 0;
      const remaining     = totalProgress - totalPaid;
      return {
        company: c,
        rep: { ...rep, totalProgress, totalPaid, remaining }
      };
    })
    // Filtreyi kaldırdık: tüm firmalar listelenecek
    .sort((a, b) => {
      const aVal = a.rep[sortCol] || 0;
      const bVal = b.rep[sortCol] || 0;
      return sortDir === 'asc' ? aVal - bVal : bVal - aVal;
    });

  const toggleSort = col => {
    if (sortCol === col) {
      setSortDir(d => (d === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortCol(col);
      setSortDir('desc');
    }
  };

  // Toplam kartları için hesaplamalar
  const toplamHak        = data.reduce((sum, x) => sum + x.rep.totalProgress, 0);
  const toplamAlinan     = data.reduce((sum, x) => sum + x.rep.totalPaid, 0);
  const toplamKalan      = data.reduce((sum, x) => sum + x.rep.remaining, 0);
  const toplamFaturaKes  = data.reduce((s, x) => s + (x.rep.totalConstructionPaymentInvoiceAmount || 0), 0);
  const toplamFaturaKalan= data.reduce((s, x) => s + ((x.rep.totalPaid || 0) - (x.rep.totalConstructionPaymentInvoiceAmount || 0)), 0);

  return (
    <div className="construction-list">
      <Navbar />
      <div className="construction-list__content">
        <div className="construction-list__header">
          <h1>İnşaat Firmaları Hakediş-Alacak Raporu</h1>
        </div>

        <div className="construction-list__totals">
          <div className="construction-list__totals-card construction-list__totals-card--progress">
            <div className="construction-list__totals-label">Toplam Hakediş</div>
            <div className="construction-list__totals-value">{fmtTL(toplamHak)}</div>
          </div>
          <div className="construction-list__totals-card construction-list__totals-card--paid">
            <div className="construction-list__totals-label">Toplam Alınan Ödeme</div>
            <div className="construction-list__totals-value">{fmtTL(toplamAlinan)}</div>
          </div>
          <div className="construction-list__totals-card construction-list__totals-card--remaining">
            <div className="construction-list__totals-label">Kalan Toplam Alacak</div>
            <div className="construction-list__totals-value">{fmtTL(toplamKalan)}</div>
          </div>
          <div className="construction-list__totals-card construction-list__totals-card--invoiced">
            <div className="construction-list__totals-label">Toplam Kesilen Fatura</div>
            <div className="construction-list__totals-value">{fmtTL(toplamFaturaKes)}</div>
          </div>
          <div className="construction-list__totals-card construction-list__totals-card--tobebilled">
            <div className="construction-list__totals-label">Toplam Kalan Kesilecek Fatura</div>
            <div className="construction-list__totals-value">{fmtTL(toplamFaturaKalan)}</div>
          </div>
        </div>

        <div className="construction-list__table-container">
          <table className="construction-list__table">
            <thead>
              <tr>
                <th>Firma Adı</th>
                <th
                  className="construction-list__th--sortable"
                  onClick={() => toggleSort('totalProgress')}
                >
                  Hakediş {sortCol === 'totalProgress' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
                </th>
                <th>Ödenen</th>
                <th
                  className="construction-list__th--sortable"
                  onClick={() => toggleSort('remaining')}
                >
                  Kalan {sortCol === 'remaining' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {data.map(({ company, rep }) => {
                const maxRemain = Math.max(...data.map(d => d.rep.remaining));
                const opacity   = maxRemain ? Math.max(0.3, rep.remaining / maxRemain) : 0.3;
                const fontColor = opacity > 0.5 ? '#fff' : '#000';
                return (
                  <tr key={company.id}>
                    <td className="construction-list__cell">{company.name}</td>
                    <td className="construction-list__cell">{fmtTL(rep.totalProgress)}</td>
                    <td className="construction-list__cell">{fmtTL(rep.totalPaid)}</td>
                    <td
                      className="construction-list__cell construction-list__cell--remaining"
                      style={{
                        backgroundColor: `rgba(0,128,0,${opacity})`,
                        color: fontColor
                      }}
                    >
                      {fmtTL(rep.remaining)}
                    </td>
                    <td className="construction-list__cell construction-list__cell--actions">
                      <button
                        className="construction-list__actions-button"
                        onClick={() => navigate(`/rentaccountpage/${company.id}`)}
                      >
                        <FaArrowRight />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
